import { QueryObserverOptions } from "@tanstack/react-query"

import { TestPostalCodeRegexRequest } from "@shared/zod/schemas/requests/postalCodeRegex"
import { TestPostalCodeRegexResponse } from "@shared/zod/schemas/responses/postalCodeRegex"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

// Sets defaults used in `buildApiFromServices`
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: 5 * 60 * 1000, // 5 minutes
}

/** Tests a postal code regex and returns matching PC4 points for the map preview. */
export const testPostalCodeRegex = async (
  request: TestPostalCodeRegexRequest
): Promise<TestPostalCodeRegexResponse> => {
  const resp = await axiosAuth({
    url: "/postal-codes/testpostalcoderegex",
    method: "post",
    data: request,
  })
  return resp.data
}
